import { replacePlaceholdersFromContext } from "./placeholderUtils";

export function replacePlaceholdersInDOM(): void {
  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);

  const nodesToReplace: Text[] = [];

  while (walker.nextNode()) {
    const node = walker.currentNode as Text;
    if (node.nodeValue && node.nodeValue.includes("[")) {
      nodesToReplace.push(node);
    }
  }

  nodesToReplace.forEach((node) => {
    const originalText = node.nodeValue!;
    const newText = replacePlaceholdersFromContext(originalText);
    if (newText !== originalText) {
      node.nodeValue = newText;
    }
  });
}
